import httpManager from '../../util/common'
import newsTypeLists from '../../../static/json/news_labels.json'
import { timestampToDate, dealNewsTypeLists } from '../../util/util'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      loading: false,
      newsList: [],
      page: {
        pagenum: 1,
        pagesize: 10,
        total: 0,
        pagerCount:3,
        align: 'center',
        layouts: ['PrevPage', 'Number','NextPage'],
        perfect: true,
      }
    }
  },
  computed: {
    oaid () {
      return this.$route.params.oaid
    },
    locale () {
      return Cookies.get('locale') || 'zh'
    },
    tableColumn () {
      return [
        {title: this.$t('esg.esg_news_time'), field: 'time'},
        {title: this.$t('esg.esg_news_title'), field: 'title', type: 'html', className: 'click-cell-style', formatter: ({row}) => {
          return `<a target="_blank" href=/esgpublicsentiment-detail?news_id=${row.news_id}>${row.title}</a>`
        }},
        {title: this.$t('esg.esg_news_level_1'), field: 'level_1'},
        {title: this.$t('esg.esg_news_level_2'), field: 'level_2'}
      ]
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      this.newsList = []
      this.page.total = 0
      let params = new Map()
      const str = dealNewsTypeLists('A')
      params.set('news_type', str)
      params.set('oaid', this.oaid)
      params.set('pagenum', this.page.pagenum)
      params.set('pagesize', this.page.pagesize)
      httpManager('esg_news', params)
        .then(res => {
          const { data } = res.data
          if (Object.prototype.toString.call(data).substring(8, 14) === 'Object') {
            this.page.total = res.data.page.total
            this.loading = false
            return
          }
          data.forEach(item  => {
            item.time = timestampToDate(item.ctime, true)
            newsTypeLists[this.locale].forEach(el => {
              if (el.children) {
                el.children.forEach(val => {
                  if (val.value == item.class) {
                    item.level_1 = el.title
                    item.level_2 = val.title
                  }
                })
              }
            });
          })
          this.newsList = data
          this.page.total = res.data.page.total
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    onChange ({ currentPage }) {
      this.page.pagenum = currentPage
      this.getData()
    }
  }
}



// WEBPACK FOOTER //
// ./src/esg/js/esg_entity_news.js